import EditIcon from "@mui/icons-material/Edit";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import Switch from "@mui/material/Switch";
import React, { useState } from "react";
import { useQueryClient, useMutation } from "@tanstack/react-query";
import {
  handleUpdateProductStatus,
  handleUpdateProductStockStatus,
} from "../../../apis/product";
import Spinner from "../../../components/spinner";
import Errors from "../../errors";
import ReviewsIcon from "@mui/icons-material/Reviews";
import MuiAlert from "@mui/material/Alert";
import { Link, useSearchParams } from "react-router-dom";
import useRead from "../../../hooks/useRead";
import Pagination from "../../../components/elements/pagination";
import useReadUpdated from "../../../hooks/updated/useRead";
import DeleteModal from "../../../components/elements/deleteModal";
import useDelete from "../../../hooks/product/useDelete";
import useGet from "../../../hooks/useGet";
import useDownload from "../../../hooks/product/useDownload";
import toast from "react-hot-toast";
import QuickUpdatePriceModal from "./QuickUpdatePriceModal";
const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});
function Products() {
  const [searchParams, setSearchParams] = useSearchParams();
  let initialData = {
    pageNo: searchParams.get("pageNo") || 0,
    limit: searchParams.get("limit") || 50,
    searchQuery: searchParams.get("searchQuery") || "",
    brand_id: searchParams.get("brand_id") || "",
  };
  const queryClient = useQueryClient();
  const [productVisibiliyId, setProductVisibiltyId] = useState(0);
  const [productStockId, setProductStockId] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);

  const changeStatus = useMutation((data) => handleUpdateProductStatus(data), {
    onSuccess: (data) => {
      if (data.status === 200) {
        queryClient.invalidateQueries(["product/list"]);
        setProductVisibiltyId(0);
      }
    },
  });
  const handleChangeStatus = (e, id) => {
    setProductVisibiltyId(id);
    let status = e.target.checked;
    let data = {
      id,
      status,
    };
    changeStatus.mutate(data);
  };

  // Stock status handler
  const changeStockStatus = useMutation(
    (data) => handleUpdateProductStockStatus(data),
    {
      onSuccess: (data) => {
        if (data.status === 200) {
          queryClient.invalidateQueries(["product/list"]);
          setProductStockId(0);
        }
      },
    }
  );
  const handleChangeStockStatus = (e, id) => {
    setProductStockId(id);
    let out_of_stock = e.target.checked; // checked means in stock
    let data = {
      id,
      in_stock: out_of_stock,
    };
    console.log(data);

    changeStockStatus.mutate(data);
  };
  const { data, paramsObject, setGetListParams } = useRead({
    method: "GET",
    url: "product/list",
    initialData,
  });
  const [searchVal, setSearcVal] = useState("");
  const limit = 50;
  const handleSearchVal = (e) => {
    let value = e.target.value;
    let copyPrams = {
      ...paramsObject,
      searchQuery: value,
    };
    setSearchParams(copyPrams);
    setGetListParams(copyPrams);
  };

  // Use the pagination data from API response
  const totalCount = data?.data?.total_count;
  const perPage = data?.data?.per_page || paramsObject.limit;
  const pageNo =
    data?.data?.page_no !== undefined
      ? data?.data?.page_no
      : paramsObject.pageNo;
  const pageCount = totalCount && perPage ? Math.ceil(totalCount / perPage) : 0;

  const handlePageClick = (val) => {
    let pageNo = {
      ...paramsObject,
      pageNo: val.selected,
    };
    setCurrentPage(val.selected);
    setGetListParams(pageNo);
    setSearchParams(pageNo);
  };

  const handleSetLimit = (e) => {
    let value = e.target.value;
    let copyPrams = {
      ...paramsObject,
      limit: value,
    };
    setSearchParams(copyPrams);
    setGetListParams(copyPrams);
  };

  // Fetch brand list
  const { data: brandList } = useRead({
    url: "brand/list",
    initialData: {
      pageNo: 0,
      limit: 50,
      searchQuery: "",
    },
    method: "GET",
  });

  // Restore brand filter function
  const handleFilterByBrand = (e) => {
    let data = {
      ...paramsObject,
      brand_id: e.target.value,
      pageNo: 0, // Reset page number when brand changes
    };
    setGetListParams(data);
    setSearchParams(data);
  };

  // Download hook for brand-wise product download
  const brandName =
    paramsObject.brand_id && brandList?.data?.data
      ? brandList.data.data.find((b) => b.brand_id === paramsObject.brand_id)
          ?.name
      : null;
  const { downloadFile: downloadBrandProducts } = useDownload({
    url: "product/brand_wise_excel_download",
    paramKey: "brand_id",
    onSuccess: () => toast.success("File downloaded successfully"),
    onError: (err) => toast.error(err.parsedMessage || "Unknown error"),
  });

  // Download handler
  const handleDownload = () => {
    const fileName = brandName
      ? `${brandName}_Brand_Products.xlsx`
      : "All_Brand_Products.xlsx";
    downloadBrandProducts(paramsObject.brand_id || "", fileName);
  };

  /* Category list API call - commented out
    const { data:categoryList } = useRead({
        url: 'categorylist',
        initialData,
        method:"GET"
    })
    */

  /* Category filter function - commented out
    const handleFilterByCategory = (e) => {
        let data = {
            ...paramsObject,
            category_id: e.target.value
        };
        setGetListParams(data)
        setSearchParams(data)
    }
    */

  const [products, setProducts] = useState(null);
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
  const [priceModalProduct, setPriceModalProduct] = useState(null);
  const handleDelete = (productId) => {
    setProducts(productId);
    setDeleteModalOpen(true);
  };
  const { handleDelete: onDeleteProduct, isDeleting } = useDelete({
    url: "product/delete",
    refreshUrl: "product/list",
    successToastMessage: "Product Deleted Successfully",
    onSuccess: () => {
      setDeleteModalOpen(false);
    },
  });
  return (
    <>
      <div className="category px-4">
        <div className="category__head headingBorder__b">
          <h2 className="titleHeading">Products</h2>
        </div>
        <div className="category_table py-5 space-y-5">
          <div className="flex flex-wrap items-end gap-4">
            <div className="">
              <input
                onChange={handleSearchVal}
                value={paramsObject.searchQuery}
                type="text"
                placeholder="Search By Key Word...."
                className="input w-40"
              />
            </div>
            <div>
              <Link to={`add-product`} className="block">
                <Button
                  variant="outlined"
                  startIcon={<AddIcon />}
                  className="primaryBtn-outlined"
                >
                  Add Product
                </Button>
              </Link>
            </div>
            <div>
              <Button
                variant="outlined"
                className="primaryBtn-outlined"
                onClick={handleDownload}
              >
                Download
              </Button>
            </div>
            <div>
              <label htmlFor="" className="label">
                Limit
              </label>
              <select
                name="limit"
                value={data.data?.per_page}
                className="input"
                onChange={handleSetLimit}
              >
                {Array(5)
                  .fill(1)
                  .map((_, idx) => {
                    return (
                      <option key={idx} value={(idx + 1) * 10}>
                        {(idx + 1) * 10}
                      </option>
                    );
                  })}
              </select>
            </div>
          </div>
          {data.isLoading || data.isFetching ? (
            <Spinner />
          ) : data.status === "error" ? (
            <Errors errorObject={data.error} inline />
          ) : (
            <div className="overflow-x-auto bg-white rounded-lg shadow overflow-y-auto relative">
              <table className="border-collapse table-auto w-full whitespace-no-wrap bg-white table-striped relative">
                <thead>
                  <tr className="text-left">
                    <th className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs text-center">
                      Product Image
                    </th>
                    <th className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs">
                      <p className="w-36">Name</p>
                    </th>
                    <th className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs">
                      Item Code
                    </th>
                    <th className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs">
                      SKU Code
                    </th>
                    <th className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs">
                      HSN Code
                    </th>
                    <th className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs">
                      Article No.
                    </th>
                    <th className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs">
                      Parent Article No.
                    </th>
                    <th className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs">
                      <div className="w-36">
                        Brand
                        <select
                          className="input mt-2"
                          value={paramsObject.brand_id}
                          onChange={handleFilterByBrand}
                        >
                          <option value="">--Filter By Brand--</option>
                          {brandList?.data?.data?.map((it) => (
                            <option key={it.brand_id} value={it.brand_id}>
                              {it.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </th>
                    {/* <th className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs">
                      Price
                    </th> */}
                    <th className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs">
                      <p className="w-32">Action</p>
                    </th>
                    <th className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs">
                      <p className="w-36">Visibility</p>
                    </th>
                    <th className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs">
                      <p className="w-36">Stock Available</p>
                    </th>
                    <th className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs">
                      Variants
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {data.data?.data?.length === 0 ? (
                    <tr>
                      <td
                        colSpan={8}
                        className="text-center py-8 text-gray-500 font-medium"
                      >
                        No Data Found
                      </td>
                    </tr>
                  ) : (
                    data.data?.data?.map((productData, idx) => {
                      const {
                        image_path,
                        product_code,
                        product_name,
                        product_type,
                        home,
                        category_name,
                        brand_name,
                        product_id,
                        status,
                        id,
                        mrp_price,
                        quantity,
                        item_code,
                        sku,
                        sku_code,
                        parent_article_no,
                        article_no,
                        hsn_code,
                      } = productData;
                      return (
                        <tr key={idx}>
                          <td className="border-dashed border-t border-gray-200 firstName">
                            <div className="w-20 h-20 mx-auto p-4">
                              {image_path ? (
                                <img
                                  src={image_path}
                                  alt={`${product_name}`}
                                  className="w-full h-full object-contain"
                                />
                              ) : (
                                <div className="w-full h-full text-center bg-gray-200 flex items-center justify-center text-gray-500 text-xs font-medium rounded">
                                  No Image
                                </div>
                              )}
                            </div>
                          </td>
                          <td className="border-dashed border-t border-gray-200 firstName w-36">
                            <span className="text-gray-700 px-6 py-3 flex items-center text-sm">
                              {product_name}
                            </span>
                          </td>
                          <td className="border-dashed border-t border-gray-200 firstName">
                            <span className="text-gray-700 px-6 py-3 flex items-center text-sm">
                              {item_code ? item_code : "---"}
                            </span>
                          </td>
                          <td className="border-dashed border-t border-gray-200 firstName">
                            <span className="text-gray-700 px-6 py-3 flex items-center text-sm">
                              {/* {sku_code ? sku_code : "----"} */}
                              {sku_code}
                            </span>
                          </td>
                          <td className="border-dashed border-t border-gray-200 firstName">
                            <span className="text-gray-700 px-6 py-3 flex items-center text-sm">
                              {hsn_code ? hsn_code : "---"}
                            </span>
                          </td>
                          <td className="border-dashed border-t border-gray-200 firstName">
                            <span className="text-gray-700 px-6 py-3 flex items-center text-sm">
                              {article_no ? article_no : "----"}
                            </span>
                          </td>
                          <td className="border-dashed border-t border-gray-200 firstName">
                            <span className="text-gray-700 px-6 py-3 flex items-center text-sm">
                              {parent_article_no ? parent_article_no : "---"}
                            </span>
                          </td>
                          <td className="border-dashed border-t border-gray-200 firstName">
                            <span className="text-gray-700 px-6 py-3 flex items-center text-sm">
                              {brand_name ? brand_name : "---"}
                            </span>
                          </td>
                          {/* <td className="border-dashed border-t border-gray-200 firstName">
                          <span className="text-gray-700 px-6 py-3 flex items-center text-sm">
                            {mrp_price}
                          </span>
                          </td> */}
                          <td className="border-dashed border-t border-gray-200 emailAddress">
                            <div className="flex items-center justify-center gap-1">
                              <IconButton
                                onClick={() => setPriceModalProduct(productData)}
                                title="Quick Update Prices"
                                size="small"
                              >
                                <AttachMoneyIcon fontSize="small" />
                              </IconButton>
                              <Link to={`product-reviews/${id}`}>
                                <IconButton title="Reviews" size="small">
                                  <ReviewsIcon fontSize="small" />
                                </IconButton>
                              </Link>
                              <Link to={`edit-product/${id}`}>
                                <IconButton title="Edit" size="small">
                                  <EditIcon fontSize="small" />
                                </IconButton>
                              </Link>
                              <div onClick={() => handleDelete(id)}>
                                <IconButton title="Delete" size="small">
                                  <DeleteIcon fontSize="small" />
                                </IconButton>
                              </div>
                            </div>
                          </td>
                          <td className="border-dashed border-t border-gray-200 emailAddress">
                            <div className="flex items-center justify-center">
                              {id === productVisibiliyId ? (
                                <Spinner className={"w-8 h-8"} />
                              ) : (
                                <>
                                  <span className="text-gray-700 text-sm">
                                    Hide
                                  </span>
                                  <Switch
                                    inputProps={{ "aria-label": "controlled" }}
                                    onChange={(e) => handleChangeStatus(e, id)}
                                    className="hide_show_switch"
                                    checked={status}
                                  />
                                  <span className="text-gray-700 text-sm">
                                    Show
                                  </span>
                                </>
                              )}
                            </div>
                          </td>
                          {/* Stock toggle */}
                          <td className="border-dashed border-t border-gray-200 emailAddress">
                            <div className="flex items-center justify-center">
                              {id === productStockId ? (
                                <Spinner className={"w-8 h-8"} />
                              ) : (
                                <>
                                  <span className="text-gray-700 text-sm">
                                    No
                                  </span>
                                  <Switch
                                    inputProps={{
                                      "aria-label": "stock-controlled",
                                    }}
                                    onChange={(e) =>
                                      handleChangeStockStatus(e, id)
                                    }
                                    className="hide_show_switch"
                                    checked={productData.in_stock}
                                  />
                                  <span className="text-gray-700 text-sm">
                                    Yes
                                  </span>
                                </>
                              )}
                            </div>
                          </td>
                          <td className="border-dashed border-t border-gray-200 px-6 ">
                            <Link
                              to={`/catalog/products/${id}/product-variants?product_name=${encodeURIComponent(
                                product_name
                              )}`}
                              className="text-white bg-primary text-center   rounded-lg px-3 py-2  items-center text-sm"
                            >
                              Variants
                            </Link>
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>
          )}
          <div>
            <Pagination
              currentPage={pageNo}
              lengthofItems={totalCount}
              limit={perPage}
              onPageChange={handlePageClick}
              pageCount={pageCount}
            />
          </div>
        </div>
      </div>
      {/* <Snackbar open={isDeletedSuccess} autoHideDuration={6000} onClose={() => setIsDeletedSuccess(false)}>
                <Alert onClose={() => setIsDeletedSuccess(false)} severity="success" sx={{ width: '100%' }}>
                    Product Deleted Succesfully
                </Alert>
            </Snackbar> */}

      <DeleteModal
        open={isDeleteModalOpen}
        handleClose={() => setDeleteModalOpen(false)}
        title={"Product Delete"}
        message={"Are you sure you want to delete this product?"}
        onDelete={() => onDeleteProduct({ id: products })}
        isLoading={isDeleting}
      />

      <QuickUpdatePriceModal
        open={!!priceModalProduct}
        onClose={() => setPriceModalProduct(null)}
        product={priceModalProduct}
      />
    </>
  );
}

export default Products;
